import React from "react";
import "./MapSection.css";
import MapImg from "../../images/map.png";
import Offices from "../OfficeList/Offices";

export default function MapSection() {
  return (
    <section className="map-section" aria-labelledby="map-heading">
      <div className="map-container">
        <div className="map-wrapper">
          <img
            src={MapImg}
            alt="World map with shipping points"
            className="map-image"
          />
          <div className="map-pin pin-1" title="Gulf / UAE" />
          <div className="map-pin pin-2" title="Pakistan" />
          <div className="map-pin pin-3" title="Indonesia" />
        </div>

        <div className="rightSideBoxes">
          <div className="map-details" id="map-heading">
            <h2>Logistics Details</h2>
            <ul className="logistics-list">
              <li>
                <strong>Shipping Method:</strong> Containerized marine
                deliveries
              </li>
              <li>
                <strong>Cold Chain Integrity:</strong> Maintained from packing
                to port
              </li>
              <li>
                <strong>Tracking:</strong> Real-time vessel tracking &
                temperature monitoring
              </li>
            </ul>
          </div>
          <Offices />
        </div>
      </div>
    </section>
  );
}
